import React from 'react';
import { connect } from 'react-redux'

import { strings } from "../../../constants/strings";
import { ComingSoonBadges } from "../../../components/Badges"

import DashboardModal from '../../../assets/css/comingSoon.css'

const lang = document.documentElement.lang.slice(0, 2);

class ComingSoon extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillUnmount() {

  }
  render() {
    //let devicesImg = '/react/images/dashboard/' + strings.Web_Dashboard_Devices_img 
    let devicesImg = '/react/images/qr/one_link_qr.png'
    return (
      <div className='row cmngsn-container container' style={{
        color: 'white'
      }}>
          <div className="cmngsn-title col-md-12">
            <h1 className="modal-title center">{strings.ComingSoon_page_title}</h1>
          </div>
          <div className="cmngsn-text col-md-12">
            <div className='center'>{strings.ComingSoon_page_description}</div>
          </div>
          <div className="cmngsn-image col-md-12 cmngsn-dwn-container">
            <img className="qr-img" src={devicesImg} alt=""/>
            <div className="cmngsn-badges">
            <ComingSoonBadges/>
          </div>
          </div>   
          {/*       
          <div className="cmngsn-text-orange col-md-12">
            <div className='center'>{strings.ComingSoon_page_actiontext}</div>
          </div>
          */}
      </div>
    );
  }
}
export default connect(/*mapStateToProps, mapDispatchToProps*/)(ComingSoon)
